import * as React from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useState, useEffect } from "react";
import { auth } from '../../../contexts/authentication';
import { UserData, getUser } from '../../../frontend/pages/getUserDB';
import WarningAlert from '../WarningAlert';
import { updateProfile } from 'firebase/auth';

interface Props {
  showWhatsappModal: boolean;
  setShowWhatsappModal: React.Dispatch<React.SetStateAction<boolean>>;
  setShowSuccessAlert: React.Dispatch<React.SetStateAction<boolean>>;
  setMessageAlert: React.Dispatch<React.SetStateAction<string>>;
}

export default function ChangePhone({
  showWhatsappModal,
  setShowWhatsappModal,
  setShowSuccessAlert,
  setMessageAlert
}: Props) {
  const currentUser = auth.currentUser;
  const [userDB, setUserDB] = useState<UserData>();
  const [whatsapp, setWhatsapp] = useState<string>('');
  const [showWarningAlert, setShowWarningAlert] = useState(false);
  const [warningMessage, setWarningMessage] = useState('');


  useEffect(() => {
    const dataUser = async () => {
      const data = await getUser();
      setUserDB(data);
    }
    dataUser();
  }, []);

  useEffect(() => {
    if (showWarningAlert) {
      setTimeout(() => {
        setShowWarningAlert(false)
      }, 6000)
    }
  }, [showWarningAlert]);


  const handleClick = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const regex = /^\(\d{2}\)\s?\d{4,5}-\d{4}$/;

    if (regex.test(whatsapp)) {      
      try {
        const response = await fetch("/update-user", {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            user: { ...userDB, whatsapp: whatsapp }
          }),
        });
        const data = await response.json();
        setUserDB(data.user);

        if (!response.ok) {
          console.error('Erro ao alterar WhatsApp no dbsalepage');
        } 
        setShowSuccessAlert(true);
        setMessageAlert('Seu número de WhatsApp já foi alterado.');
        setShowWhatsappModal(false);
      } catch (err) {
        console.error('Erro ao alterar WhatsApp:', err);
      }
    } else {
      // alert('Formato de WhatsApp inválido!');
      setShowWarningAlert(true);
      setWarningMessage('Formato de WhatsApp inválido!');
    }
  }

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let value = e.target.value;

    // Remove tudo que não seja número
    value = value.replace(/\D/g, '');

    // Formata a entrada conforme a quantidade de números
    if (value.length <= 2) {
      value = `(${value}`;
    } else if (value.length <= 7) {
      value = `(${value.slice(0, 2)}) ${value.slice(2)}`;
    } else {
      value = `(${value.slice(0, 2)}) ${value.slice(2, 7)}-${value.slice(7, 11)}`;
    }

    setWhatsapp(value);
  };

  return (
    <Dialog
      open={showWhatsappModal}
      onClose={() => setShowWhatsappModal(false)}
      slotProps={{
        paper: {
          component: 'form',
          onSubmit: (e: React.FormEvent<HTMLFormElement>) => {
            handleClick(e);
          },
          sx: { backgroundImage: 'none', width: '100%' },
        },
      }}
    >
      <DialogTitle>Editar número de WhatsApp</DialogTitle>
      <DialogContent
        sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}
      >
        <DialogContentText>
          Digite seu novo número de WhatsApp.
        </DialogContentText>
        <Box
          sx={{ '& > :not(style)': { m: 1, width: '25ch' } }}
        >
          <TextField
            id="standard-basic"
            label="Novo número de WhatsApp"
            // variant="standard"
            value={whatsapp}
            onChange={handleInputChange}
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{ pb: 3, px: 3 }}>
        <Button onClick={() => setShowWhatsappModal(false)}>Cancelar</Button>
        <Button variant="contained" type="submit">
          Continuar
        </Button>
      </DialogActions>
      {showWarningAlert && (
        <WarningAlert
          message={warningMessage}
        />
      )}
    </Dialog>
  );
}